<div class="window-content">
  <prime-nav-overlay *ngIf="showOverlay"></prime-nav-overlay>
  <router-outlet></router-outlet>
</div>
